import { ToolbarPosition } from '../types/toolbar';

export function getToolbarPosition(rect: DOMRect) {
  const toolbarX = rect.left + window.scrollX;
  const toolbarY = rect.bottom + window.scrollY + 8; // Add 8px below the selection for better visibility
  const toolbarPosition: ToolbarPosition = { x: toolbarX, y: toolbarY };

  return toolbarPosition;
}
